import React from 'react';
import { ArrowRight } from 'lucide-react';

const ResourceLink = ({ href = '#', label = 'View Resource' }) => (
    <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="font-dashboard inline-flex items-center gap-2 text-[10px] leading-4 uppercase tracking-[0.6px] text-[#38433A] transition-colors hover:text-[#2C352E]"
    >
        <span>{label}</span>
        <ArrowRight className="h-3.5 w-3.5" />
    </a>
);

export default ResourceLink;
